import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Table from "../../../core/pagination/datatable";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { ErrorToaster } from "../../components/toaster/Toaster";
import { deleteAlert } from "../../components/sweetAlert";
import { Debounce, getDate } from "../../../utils";
import { all_routes } from "../../../Router/all_routes";
import StockTransferServices from "../../../services/StockTransfer";

const StockTransfer = () => {

  const routes = all_routes;

  // *For Loader
  const [loader, setLoader] = useState(false);

  // *For Stock Transfer
  const [stockTransfers, setStockTransfers] = useState([]);

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  // *For Filter
  const [filters, setFilters] = useState({});

  // *For Handle Filter
  const handleFilter = (data) => {
    Debounce(() => getStockTransfers(1, '', data));
  }

  // *For Get Stock Transfer
  const getStockTransfers = async (page, limit, filter) => {
    setLoader(true)
    try {
      const Page = page ? page : currentPage
      const Limit = limit ? limit : pageLimit
      const Filter = { ...filters, ...filter }
      setCurrentPage(Page)
      setPageLimit(Limit)
      setFilters(Filter)
      let params = {
        page: Page,
        limit: Limit
      }
      params = { ...params, ...Filter }
      const { data, total_count } = await StockTransferServices.getStockTransfers(params)
      setStockTransfers(data)
      setTotalCount(total_count)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false)
    }
  }

  // *For Delete Stock Transfer
  const deleteStockTransfer = async (id) => {
    try {
      const isConfirmed = await deleteAlert()

      if (isConfirmed) {
        // await StockTransferServices.deleteStockTransfer(id);
        getStockTransfers();

        Swal.fire({
          title: "Deleted!",
          text: "Stock transfer has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.close();
      }
    } catch (error) {
      ErrorToaster(error)
    }
  }

  const columns = [
    {
      title: "Ref Number",
      dataIndex: "reference_no",
    },
    {
      title: "From Store",
      dataIndex: "from_store",
      render: (store) => (
        <>
          {store?.name}
        </>
      ),
    },
    {
      title: "To Store",
      dataIndex: "to_store",
      render: (store) => (
        <>
          {store?.name}
        </>
      ),
    },
    {
      title: "No Of Products",
      dataIndex: "items",
      render: (items) => (
        <>
          {items?.length}
        </>
      ),
    },

    {
      title: "Quantity Transferred",
      dataIndex: "items",
      render: (items) => (
        <>
          {items?.reduce((acc, item) => acc + parseInt(item.quantity), 0)}
        </>
      ),
    },

    {
      title: "Date",
      dataIndex: "created_at",
      render: (text) => (
        <span>
          {getDate(text)}
        </span>
      ),
      sorter: (a, b) => a.created_at.length - b.created_at.length,
    },

    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
            <Link className="action-set" to="#" data-bs-toggle="dropdown" aria-expanded="true">
              <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
            </Link>
            <ul className="dropdown-menu">
              
              <li>
                <Link to="#" className="dropdown-item" data-bs-toggle="modal" data-bs-target="#"><i data-feather="edit" className="feather-edit me-2"></i>Edit Stock Transfer</Link>
              </li>
              {/* <li>
                <Link to="#" className="dropdown-item" data-bs-toggle="modal" data-bs-target="#showpayment"><i data-feather="dollar-sign" className="feather-dollar-sign"></i>Show Payments</Link>
              </li> */}
              {/* <li>
                <Link to="#" className="dropdown-item" data-bs-toggle="modal" data-bs-target="#createpayment"><i data-feather="plus-circle" className="feather-plus-circle me-2"></i>Create Payment</Link>
              </li> */}
              {/* <li>
                <Link to="#" className="dropdown-item"><i data-feather="download" className="feather-edit me-2"></i>Download pdf</Link>
              </li> */}
              <li>
                <Link to="#" className="dropdown-item confirm-text mb-0" ><i data-feather="trash-2" className="feather-trash me-2"  ></i>Delete Stock Transfer</Link>
              </li>
            </ul>
            
          </div>
        </div>
      ),
    },
  ];

  useEffect(() => {
    getStockTransfers()
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Stock Transfer</h4>
                <h6>Manage Your Stock Transfer</h6>
              </div>
            </div>
            <div className="page-btn">
              <Link
                to={routes?.addStockTransfer}
                className="btn btn-added"
              >
                <PlusCircle className="me-2" />
                Add New Transfer
              </Link>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      className="form-control form-control-sm formsearch"
                      onChange={(e) => handleFilter({ search: e.target.value })}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  loading={loader}
                  columns={columns}
                  dataSource={stockTransfers}
                  totalCount={totalCount}
                  pageSize={pageLimit}
                  currentPage={currentPage}
                  onChange={(page, pageSize) => getStockTransfers(page, pageSize)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StockTransfer;
